/**
 * Invalid Bets — Lab `/var-invalid-betlogs`.
 * Two tabs: VARBet + Invalid Bets. Live via CM-API shared DB.
 */

export type InvalidBetsTab = 'var-bet' | 'invalid-bets'

/** Sportwise + All — Lab sport names on `orders.event_type`. */
export const INVALID_BETS_SPORTS = [
  'All',
  'Cricket',
  'Soccer',
  'Tennis',
  'Horse Racing',
  'Greyhound Racing',
] as const

export type InvalidBetsSport = (typeof INVALID_BETS_SPORTS)[number]

export interface InvalidBetRow {
  id: string
  playerName: string
  /** VAR tab only. */
  event?: string
  placedAt: string
  /** Invalid Date (Invalid) or Void Date (VAR). */
  updatedAt: string
  type: string
  selectionName: string
  odds: number | string
  stake: number | string
  /** Invalid Bets tab only. */
  invalidBy?: string
  placeIp: string
  /** Invalid Bets tab only. */
  invalidIp?: string
}

export interface InvalidBetsQuery {
  page?: number
  pageSize?: number
  tab: InvalidBetsTab
  /** Usernames from hierarchy MemberPicker → Lab `playerName`. */
  members?: string[]
  fromDate?: string
  toDate?: string
  /** Sportwise filter; All = omit on the wire. */
  sport?: InvalidBetsSport
}

export interface InvalidBetsResult {
  rows: InvalidBetRow[]
  total: number
  page: number
  pageSize: number
  tab: InvalidBetsTab
}
